import * as _ from "lodash";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import FormData from "csi/action/FormData";
import csi from "csi/main";
import New from "csi/table/New";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import Query from "csi/xml/Query";

const INDEX_FOODS_VIEW = 0;
const INDEX_SKUS_VIEW = 1;

const NewSRLineItemFromFoodSKUWizard = declare([New, ActionControllerMixin], {

	_currentSKUNames: null,
	fdFoodsPage: null,
	fdSKUsPage: null,

	/**
	 * @override
	 * Enable next only if Food is selected
	 */
	disableNext: function(wizard, page, index) {
		return index == INDEX_FOODS_VIEW && !this.fdFoodsPage.getSelectedNode();
	},

	/**
	 * @override
	 * Enable finish only if FoodSKU is selected
	 */
	disableFinish: function(wizard, page, index) {
		return index == INDEX_SKUS_VIEW && !this.fdSKUsPage.getSelectedNodes().length;
	},

	/**
	 * @override
	 * Filter FoodSKUs by selected parent Food
	 */
	getWizardViewQuery: function(wizard, view, index) {
		if (index == INDEX_FOODS_VIEW) {
			return new Query().RefAttr("RealizedProducts", xml.OP_NOT_EQUALS, csi.EMPTY_URL);
		}
		if (index == INDEX_SKUS_VIEW) {
			return new Query().RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.fdFoodsPage.getSelectedNode().$URL);
		}
	},

	/**
	 * Get selected SKUs
	 */
	getSelectedSKUs: function() {
		return !!this.fdSKUsPage ? this.fdSKUsPage.getSelectedValue() : null;
	},

	/**
	 * @override
	 * Pass data into the next page
	 */
	 onNextPage: function(wizard, currentPage, nextPage, bFinish) {
		let fd: FormData = this.m_formData;
		const index = wizard.getIndexOfPage(nextPage);
		if (index == INDEX_FOODS_VIEW) {
			fd = this.fdFoodsPage = this.fdFoodsPage || new FormData(this);
			fd.m_bRequireOne = true;
			fd.m_bSelectOne = true;
		} else if (index == INDEX_SKUS_VIEW) {
			fd = this.fdSKUsPage = this.fdSKUsPage || new FormData(this);
			fd.m_bRequireOne = true;
			fd.m_bSelectOne = false;
			// Grey out FoodSKUs if SRLineItem exists for them already
			fd.m_bOmitSelections = true;
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
		}

		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, true) : null;
	},

	/**
	 * Checks to see if SRLineItem exists already for FoodSKU
	 * @param {Context} ctx 
	 * @param {FormData} fd 
	 * @returns {Boolean}
	 */
	_isPreSelected: function(ctx, fd) {
		const lineItems = this.m_cache.getNodes(this.getParent().LineItems);
		if (!this._currentSKUNames) {
			this._currentSKUNames = {};
			_.forEach(lineItems, (lineItem) => {
				this._currentSKUNames[lineItem.SRLineItemSKU] = true;
			});
		}

		return this._currentSKUNames[ctx.getNode().$URL];
	},

	/**
	 * @override
	 * Add SKUs parameter to request
	 */
	toWriterRequest: function() {
		const call = this.inherited<CallMethod>(arguments);
		
		const skus = this.getSelectedSKUs();
		if (skus) {
			call.addParameter("AddURLs", xml.ATTR_REFLIST, skus);
		}

		return call;
	},
});

export = NewSRLineItemFromFoodSKUWizard;